export const GenericUserCell = ({ value }: { value?: string }) => {
  return (
    <p className="text-wrap text-break text-white fs-6" style={{ maxWidth: '200px' }}>
      {value}
    </p>
  );
}